<div class="bg-gray-100 flex flex-col min-h-screen">
  <!-- Top nav-->
  <app-sidebar-header></app-sidebar-header>
  <!-- Bottom section -->
  <div class="flex-1 flex">
    <!-- Narrow sidebar-->
    <app-sidebar-nav class="hidden md:block md:flex-shrink-0 md:bg-menu"></app-sidebar-nav>
    <!-- Main area -->
    <main class="flex-1 bg-gray-100">
      <router-outlet id="content"></router-outlet>
    </main>

  </div>
</div>
